/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import IDropdown from 'models/dropdown'
// import {toast} from 'react-toastify'
import Spinner from 'layout/common/Spinner'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
// import {TextField} from 'helpers/ui-components/form/TextField'
import {Select2DropdownField} from 'helpers/ui-components/form/Select2DropdownField'
import {KTSVG, Model} from 'helpers'
import {
 fetchOrganisationMapping,
 fetchOrganisationMappingCounts,
 createOrganisationMapping,
 fetchOrganisation,
 removeOrganisationMapping,
} from 'utils/api/auth/myAccountService'
import {
 INetworkProfileTable,
 IOrganisationMappingCount,
} from 'models/MyAccount'
import {ColumnProps, IFormField} from 'models/Common'
import {toast} from 'react-toastify'
import KTTable from 'helpers/ui-components/KTTable'
import {generateRandomNo} from 'utils/helper'
import {DefaultApiResponse} from 'models/ApiResponse'
import {NetworkProfileCountCard} from './NetworkProfileCountCard'
import {
 fetchStackholderCategory,
 fetchStackholders,
} from 'utils/api/auth/registerService'
import {
 fetchState,
 fetchDistrict,
} from 'utils/api/auth/locationService'
import {KTConfirmPopup} from 'helpers/ui-components/KTConfirmPopup'
// import {ILogin} from 'models/Auth'

type IProps = {
 userId: string
 loggedInUserId: number | undefined
 type: string
 accessDetails: IFormField
}

const NetworkProfile = (props: IProps) => {
 const {t} = useTranslation()
 const [loader, setLoader] = useState(false)
 const isDisabled = false
 const [confirmModalData, setConfirmModalData] =
  useState<INetworkProfileTable | null>(null)
 const [showNetworkMemberModel, setShowNetworkMemberModel] =
  useState(false)
 const [stackholderList, setStackholderList] = useState<
  IDropdown[]
 >([])
 const [
  stackholderCategoryList,
  setStackholderCategoryList,
 ] = useState<IDropdown[]>([])
 const [organizationList, setOrganizationList] = useState<
  IDropdown[]
 >([])
 const [stateList, setStateList] = useState<IDropdown[]>([])
 const [districtList, setDistrictList] = useState<
  IDropdown[]
 >([])
 const [currentPage, setCurrentPage] = useState(1)
 const [organisationMappingRes, setOrganisationMappingRes] =
  useState<DefaultApiResponse>()
 const [
  organisationMappingCountList,
  setOrganisationMappingCountList,
 ] = useState<IOrganisationMappingCount[]>([])
 const [
  organisationMappingList,
  setOrganisationMappingList,
 ] = useState<INetworkProfileTable[]>([])
 const [tableColList, setTableColList] = useState<
  Array<ColumnProps<INetworkProfileTable>>
 >([])
 const cardColor = [
  '#FFF3C2',
  '#E3D7F5',
  '#FDC',
  '#E3F5CE',
  '#CED8E0',
 ]
 const formValues = {
  stackholder: '',
  category: '',
  organisation: [] as number[],
  state: [] as number[],
  district: [] as number[],
 }

 const {
  control,
  setValue,
  handleSubmit,
  watch,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...formValues},
 })

 const selectedStates: number[] =
  (watch('state') as unknown as number[]) ?? []

 const getOrganisationMapping = async (pageNo?: number) => {
  setLoader(true)
  const res: DefaultApiResponse | null =
   await fetchOrganisationMapping(props.userId, pageNo)
  if (res) {
   setOrganisationMappingRes(res)
   setOrganisationMappingList(res.results ?? [])
  }
  setLoader(false)
 }

 const handleDeleteBtnClick = async (
  isConfirm: boolean
 ) => {
  if (isConfirm) {
   const record: INetworkProfileTable | null =
    confirmModalData
   if (record) {
    setLoader(true)
    const res = await removeOrganisationMapping({
     organisation_id: record.organisation_id,
     user_id: props.userId,
    })
    if (res) {
     setConfirmModalData(null)
     toast.success(res)
     await getOrganisationMapping()
    }
    setLoader(false)
   }
  } else {
   setConfirmModalData(null)
  }
 }

 const handlePageChange = async (pageNo: number) => {
  setCurrentPage(pageNo)
  await getOrganisationMapping(pageNo)
 }

 const getOrganisationMappingCount = async () => {
  setLoader(true)
  const res: IOrganisationMappingCount[] | null =
   await fetchOrganisationMappingCounts(props.userId)
  if (res) {
   setOrganisationMappingCountList(res)
  }
  setLoader(false)
 }

 const getOrganisationsByFilter = async (
  categoryId?: number,
  stateIds: number[] = [],
  districtIds: number[] = []
 ) => {
  setLoader(true)
  setValue('organisation', [])

  const validCategoryId =
   categoryId && categoryId > 0 ? categoryId : undefined

  const validStateIds =
   stateIds.length > 0 ? stateIds : undefined

  const validDistrictIds =
   districtIds.length > 0 ? districtIds : undefined

  const res: IDropdown[] = await fetchOrganisation(
   validCategoryId,
   validStateIds,
   validDistrictIds
  )

  if (res) {
   setOrganizationList(res)
  }
  setLoader(false)
 }

 async function submitFormData(formData: IFormField) {
  setLoader(true)
  const payload = {
   user_id: props.userId,
   organisation_id: formData.organisation,
  }
  const res = await createOrganisationMapping(payload)
  if (res) {
   toast.success(res)
   setShowNetworkMemberModel(false)
   await getOrganisationMappingCount()
   await getOrganisationMapping()
  }
  setLoader(false)
 }

 const renderTableData = () => {
  setLoader(true)

  const columns: Array<ColumnProps<INetworkProfileTable>> =
   [
    {
     key: 'srNo',
     title: t(
      'myAccountPage.businessProfile.networkProfile.tableColumn.srNo'
     ),
     className: 'w-[80px] text-center',
     isSrNo: true,
    },
    {
     key: 'organisation',
     title: t(
      'myAccountPage.businessProfile.networkProfile.tableColumn.stakeholderName'
     ),
    },
    {
     key: 'phone_number',
     title: t(
      'myAccountPage.businessProfile.networkProfile.tableColumn.mobile'
     ),
     className: 'w-[80px]',
    },
    {
     key: 'stakeholder',
     title: t(
      'myAccountPage.businessProfile.networkProfile.tableColumn.stakeholder'
     ),
    },
    {
     key: 'category',
     title: t(
      'myAccountPage.businessProfile.networkProfile.tableColumn.stakeholderType'
     ),
    },
    {
     key: 'organisation_mapping_created_since',
     title: t(
      'myAccountPage.businessProfile.networkProfile.tableColumn.associatedSince'
     ),
    },
    {
     key: 'action',
     title: t(
      'myAccountPage.businessProfile.networkProfile.tableColumn.action'
     ),
     render: (_, record) => {
      return (
       <div className='flex items-center justify-center w-full'>
        <i
         className='fa fa-trash text-lg cursor-pointer text-gray-700'
         aria-hidden='true'
         onClick={() => {
          setConfirmModalData(record)
         }}
        />
       </div>
      )
     },
    },
   ]
  setTableColList(columns)
  setLoader(false)
 }

 useEffect(() => {
  void getOrganisationMappingCount()
  void getOrganisationMapping()
 }, [props.userId])

 useEffect(() => {
  if (organisationMappingList) {
   renderTableData()
  }
 }, [organisationMappingList])

 const getStackholderCategory = async (
  stackholderId: number
 ) => {
  setLoader(true)
  setValue('category', '')
  setValue('organisation', [])
  setStackholderCategoryList([])
  setOrganizationList([])
  const res: IDropdown[] = await fetchStackholderCategory(
   stackholderId,
   'business_profile',
   props.userId
  )
  if (res) {
   setStackholderCategoryList(res)
  }
  setLoader(false)
 }

 const handleStateChange = async (stateIds: number[]) => {
  setValue('district', [])
  setValue('organisation', [])
  setDistrictList([])
  setOrganizationList([])

  if (stateIds.length > 0) {
   setLoader(true)
   const districtPromises = stateIds.map(async (id) => {
    return fetchDistrict(id)
   })
   const districtResults = await Promise.all(
    districtPromises
   )
   const allDistricts: IDropdown[] = districtResults
    .flat()
    .filter(Boolean)
    .reduce((acc: IDropdown[], curr: IDropdown) => {
     if (!acc.find((d) => d.id === curr.id)) acc.push(curr)
     return acc
    }, [])
   setDistrictList(allDistricts)
   setLoader(false)
   await getOrganisationsByFilter(
    Number(watch('category')) || undefined,
    stateIds,
    []
   )
  } else {
   await getOrganisationsByFilter(
    Number(watch('category')) || undefined,
    [],
    []
   )
  }
 }

 const handleDistrictChange = async (
  districtIds: number[]
 ) => {
  setValue('organisation', [])
  await getOrganisationsByFilter(
   Number(watch('category')) || undefined,
   selectedStates,
   districtIds
  )
 }

 useEffect(() => {
  if (showNetworkMemberModel) {
   const loadInitialData = async () => {
    setLoader(true)
    const res: IDropdown[] = await fetchState()
    if (res) setStateList(res)
    const orgs: IDropdown[] = await fetchOrganisation()
    if (orgs) setOrganizationList(orgs)
    setLoader(false)
   }
   void loadInitialData()
  }
 }, [showNetworkMemberModel])

 useEffect(() => {
  const getStackholders = async () => {
   setLoader(true)
   const res: IDropdown[] = await fetchStackholders(
    'business_profile',
    props.userId
   )
   if (res) {
    setStackholderList(res)
   }
   setLoader(false)
  }
  void getStackholders()
 }, [props.userId])

 const sharedSelectStyle = {
  transition: 'unset',
  boxShadow: 'unset',
  border: '0px',
  borderRadius: '0px',
  padding: '0px',
  minHeight: 'auto',
 }

 const sharedClassName = `${
  isDisabled
   ? '!text-[#33393D] font-medium'
   : 'font-normal !text-[#33393D]'
 } boxed-select2 relative block text-lg border-0 !rounded-l-lg`

 return (
  <>
   {loader && <Spinner />}
   {confirmModalData && (
    <KTConfirmPopup
     showConfirmModel={confirmModalData ? true : false}
     handleConfirmBtnClick={handleDeleteBtnClick}
     yesBtnText={t('common.yes')}
     noBtnText={t('common.no')}
     title={t('common.confirmModalTitle')}
     subTitle={`${t('common.deleteConfirmModalSubTitle')} ${
      confirmModalData.organisation
     }?`}
    />
   )}
   <Model
    show={showNetworkMemberModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     setShowNetworkMemberModel(false)
    }}
    modelClass='md:w-[800px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {t(
        'myAccountPage.businessProfile.networkProfile.addMember'
       )}
      </p>
      <form
       method='POST'
       action=''
       onSubmit={handleSubmit(submitFormData)}
      >
       <div className='grid md:grid-cols-2 gap-5 w-full mt-7 text-[#171B1F]'>
        <Select2DropdownField
         label={t(
          'myAccountPage.businessProfile.networkProfile.stakeholder'
         )}
         labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
         className={sharedClassName}
         wrapperClassName='relative w-full'
         inputWrapperClassName='pl-4 py-2 px-4'
         required={true}
         disabled={false}
         isClearable={false}
         isSearchable={true}
         control={control}
         customStyle={sharedSelectStyle}
         data={stackholderList}
         rules={{
          validate: {
           required: (v: string) => {
            if (v === '')
             return `${t('helperText.plsSelect')} ${t(
              'myAccountPage.businessProfile.networkProfile.stakeholder'
             )}`
           },
          },
          onChange: async (e: {
           target: {value: number}
          }) => {
           await getStackholderCategory(e.target.value)
          },
         }}
         id='stakeholder'
         name='stakeholder'
         OptionValueKey='id'
         OptionLabelKey='name'
         placeholder={`${t('helperText.select')} ${t(
          'myAccountPage.businessProfile.networkProfile.stakeholder'
         )}`}
         errors={errors}
        />
        <Select2DropdownField
         label={t(
          'myAccountPage.businessProfile.networkProfile.category'
         )}
         labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
         className={sharedClassName}
         wrapperClassName='relative w-full'
         inputWrapperClassName='pl-4 py-2 px-4'
         required={true}
         disabled={false}
         isClearable={false}
         isSearchable={true}
         control={control}
         customStyle={sharedSelectStyle}
         data={stackholderCategoryList}
         rules={{
          validate: {
           required: (v: string) => {
            if (v === '')
             return `${t('helperText.plsSelect')} ${t(
              'myAccountPage.businessProfile.networkProfile.category'
             )}`
           },
          },
          onChange: async (e: {
           target: {value: number}
          }) => {
           const categoryId = e.target.value

           await getOrganisationsByFilter(
            categoryId,
            selectedStates,
            (watch('district') as unknown as number[]) ?? []
           )
          },
         }}
         id='category'
         name='category'
         OptionValueKey='id'
         OptionLabelKey='name'
         placeholder={`${t('helperText.select')} ${t(
          'myAccountPage.businessProfile.networkProfile.category'
         )}`}
         errors={errors}
        />

        <Select2DropdownField
         label={'State'}
         labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
         className={sharedClassName}
         wrapperClassName='relative w-full'
         inputWrapperClassName='pl-4 py-2 px-4'
         required={false}
         disabled={false}
         isClearable={true}
         isSearchable={true}
         isMultiselect={true}
         showNumberAfterRecords={true}
         showCheckbox={true}
         control={control}
         customStyle={sharedSelectStyle}
         data={stateList}
         config={{closeMenuOnSelect: false}}
         rules={{
          onChange: async (e: {
           target: {value: number[]}
          }) => {
           await handleStateChange(
            Array.isArray(e.target.value)
             ? e.target.value
             : []
           )
          },
         }}
         id='state'
         name='state'
         OptionValueKey='id'
         OptionLabelKey='name'
         placeholder={`${t('helperText.select')} State`}
         errors={errors}
        />

        <Select2DropdownField
         label={'District'}
         labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
         className={sharedClassName}
         wrapperClassName='relative w-full'
         inputWrapperClassName='pl-4 py-2 px-4'
         required={false}
         disabled={selectedStates.length === 0}
         isClearable={true}
         isSearchable={true}
         isMultiselect={true}
         showNumberAfterRecords={true}
         showCheckbox={true}
         control={control}
         customStyle={sharedSelectStyle}
         data={districtList}
         config={{closeMenuOnSelect: false}}
         rules={{
          onChange: async (e: {
           target: {value: number[]}
          }) => {
           await handleDistrictChange(
            Array.isArray(e.target.value)
             ? e.target.value
             : []
           )
          },
         }}
         id='district'
         name='district'
         OptionValueKey='id'
         OptionLabelKey='name'
         placeholder={
          selectedStates.length === 0
           ? 'Select District'
           : `${t('helperText.select')} District`
         }
         errors={errors}
        />

        <Select2DropdownField
         label={t(
          'myAccountPage.businessProfile.networkProfile.organisation'
         )}
         labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
         className={sharedClassName}
         wrapperClassName='relative md:col-span-2'
         inputWrapperClassName='pl-4 py-2 px-4'
         required={true}
         disabled={false}
         isClearable={true}
         isSearchable={true}
         isMultiselect={true}
         showNumberAfterRecords={true}
         showCheckbox={true}
         control={control}
         customStyle={sharedSelectStyle}
         data={organizationList}
         rules={{
          validate: {
           required: (v: number[]) => {
            if (!v || v.length === 0)
             return `${t('helperText.plsSelect')} ${t(
              'myAccountPage.businessProfile.networkProfile.organisation'
             )}`
           },
          },
         }}
         id='organisation'
         name='organisation'
         OptionValueKey='id'
         OptionLabelKey='name'
         placeholder={`${t('helperText.select')} ${t(
          'myAccountPage.businessProfile.networkProfile.organisation'
         )}`}
         errors={errors}
         config={{closeMenuOnSelect: false}}
        />
       </div>

       <div className='md:flex items-center justify-center mt-7'>
        <Button
         type={'submit'}
         color='blue'
         className='text-center w-full py-[9px] px-6 bg-[#4E83E4] 
                    !rounded-lg !text-base text-white font-semibold border-[#4E83E4]'
        >
         {t(
          'myAccountPage.businessProfile.networkProfile.addMemberBtn'
         )}
        </Button>
       </div>
      </form>
     </div>
    </div>
   </Model>
   <div className='w-full'>
    <div className='grid md:grid-cols-6 items-center gap-4 mb-4'>
     {organisationMappingCountList?.map(
      (val: IOrganisationMappingCount, key: number) => (
       <NetworkProfileCountCard
        key={key}
        title={val.organisation_type}
        count={val.mapping_count}
        color={
         cardColor[key] ??
         generateRandomNo(cardColor.length)
        }
       />
      )
     )}
    </div>
    <div className='w-full'>
     <div>
      <KTTable
       data={organisationMappingList}
       columns={tableColList}
       headerClass='bg-[#80868C]'
       colClass='text-[#33393D] !text-sm font-normal'
       showPagination={true}
       currentPage={currentPage}
       itemsPerPage={25}
       totalRecord={organisationMappingRes?.count}
       onPageChange={handlePageChange}
      />
      {props.accessDetails?.canAdd && (
       <div
        className='flex text-[#4E83E4] text-lg font-bold items-center w-[200px] cursor-pointer mt-4'
        onClick={() => {
         setShowNetworkMemberModel(true)
        }}
       >
        <KTSVG
         path={`/media/icons/plus.svg`}
         svgClassName={`w-4 h-4`}
        />
        <div>
         {t(
          'myAccountPage.businessProfile.networkProfile.addMember'
         )}
        </div>
       </div>
      )}
     </div>
    </div>
   </div>
  </>
 )
}

export default NetworkProfile
